import { render, staticRenderFns } from "./TheCaseStudies.vue?vue&type=template&id=fbd222e6"
import script from "./TheCaseStudies.vue?vue&type=script&lang=js"
export * from "./TheCaseStudies.vue?vue&type=script&lang=js"
import style0 from "./TheCaseStudies.vue?vue&type=style&index=0&id=fbd222e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports